import { browserEnvs } from '@paid-ui/env';
import { userManager } from '@paid-ui/models/user';

const { env } = browserEnvs;

export type AppErrorType = 'VALIDATION' | 'UNKNOWN';
export type AppErrorCode = 'NON_ASCII_PAYLOAD' | 'UNKNOWN';

const defaultExceptionDescription = {
  NON_ASCII_PAYLOAD: 'Non-ASCII characters in request payload',
  UNKNOWN: 'Unknown error',
};

const GA4_EXCEPTION_EVENT = 'paid.web-app.exception';

export function reportAppError<
  T extends Record<string, unknown> = Record<string, unknown>,
>(options: {
  type: AppErrorType;
  code: AppErrorCode;
  description?: string;
  requestId?: string;
  requestUrl?: string;
  details?: T;
}) {
  const { profile } = userManager;
  const {
    type,
    code,
    description = defaultExceptionDescription[code],
    requestId,
    requestUrl,
    details,
  } = options;

  const payload = {
    event: GA4_EXCEPTION_EVENT,
    error_type: type,
    error_code: code,
    error_message: description,
    environment: env,
    request_id: requestId ?? null,
    request_url: requestUrl ?? null,
    request_user_id: profile?.id ?? null,
    request_email: profile?.email ?? null,
    troubleshoot_detail: details ? JSON.stringify(details) : null,
  };

  if (globalThis.window === undefined) return;

  if (Array.isArray(globalThis.window.dataLayer)) {
    globalThis.window.dataLayer.push(payload);
  }

  if (typeof globalThis.window.gtag === 'function') {
    globalThis.window.gtag('event', GA4_EXCEPTION_EVENT, payload);
  }
}
